import { IValidationResult } from "@edaz/services/baseValidationService";

export interface prohibitedCharactersOptions<TEntity> {
  property: keyof TEntity;
}

export interface prohibitedCharactersParams<TEntity> {
  entity: TEntity;
}

export function isControlCharacter(char: string): boolean {
  const code = char.charCodeAt(0);
  return (code >= 0 && code <= 31) || code === 127;
}

export function prohibitedCharacters<TEntity>(
  value: string,
  options?: prohibitedCharactersOptions<TEntity>,
  params?: prohibitedCharactersParams<TEntity>
): IValidationResult {
  const prohibitedChars = ["<", ">", "\\"];
  const allowedControlChars = ["\t", "\n", "\r"];
  if (!value) {
    return {
      isValid: true,
    };
  }
  const containsInvalidCharacters = Array.from(value).some(
    char => prohibitedChars.includes(char) || (isControlCharacter(char) && !allowedControlChars.includes(char))
  );

  if (containsInvalidCharacters) {
    return {
      isValid: false,
      errors: {
        value: value,
        constraints: {
          containsProhibitedCharacters: "true",
        },
      },
    };
  }

  return {
    isValid: true,
  };
}
